import React from 'react';
import { Dropdown } from 'components/Input';

interface Props {
  value: string;
  onChange: (value: string) => void;
  options: any;
}

export default (props: Props) => {
  const { value, onChange, options } = props;
  return (
    <Dropdown
      id="table-select-dropdown"
      placeholder={value}
      defaultDropdownValue={value}
      options={options || []}
      value={options && options.find((option: any) => option.value === value)}
      onChange={(newOption) => onChange(newOption.value)}
      noBorder
      customHeight="26px"
      fontSize="12px"
      minWidthLabel="100%"
      singleValueMargin="0"
    />
  );
};
